import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { Questionnaire } from "src/models";
import axios from '../axios';


export const getKYCProgress = createAsyncThunk(
  'questionnaire/getKYCProgress',
  async ({ sectionTitleId, jwt }: { sectionTitleId: string, jwt: string }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/kyc/progress?section_title_id=${sectionTitleId}`, {
        headers: {
          'Authorization': `Bearer ${jwt}`
        }
      });
      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getClientQuestionnaires = createAsyncThunk(
  'questionnaire/getClientQuestionnaires',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/kyc-questionnaires`);
      return fulfillWithValue(data.questionnaires);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getClientKYCFiles = createAsyncThunk(
  'questionnaire/getClientKYCFiles',
  async (client_uuid: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/kyc-files/client/${client_uuid}`);
      return fulfillWithValue(data.files);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getCountries = createAsyncThunk(
  'questionnaire/getCountries',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/config`);
      return fulfillWithValue(data.configurations);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);


export const getMyProfile = createAsyncThunk(
  'questionnaire/getMyProfile',
  async (client_uuid: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/spa/client-profile/${client_uuid}`);
      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const verifyToken = createAsyncThunk(
  'questionnaire/verifyToken',
  async (token: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/spa/verify-token/${token}`, { withCredentials: true });
      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);


export const getKYCSectionMatch = createAsyncThunk(
  'questionnaire/getKYCSectionMatch',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/questionnaire-title-match`);
      return fulfillWithValue(data.data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getKYCSectionTitles = createAsyncThunk(
  'clients/getKYCSectionTitles',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/user/kyc/section-titles');
      return fulfillWithValue(data.titles);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getKYCServicesTypes = createAsyncThunk(
  'config/getKYCServicesTypes',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/kyc-service_types');
      return fulfillWithValue(data.services);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
)

export const submitQuestionnaireAns = createAsyncThunk(
  'questionnaire/submitQuestionnaireAns',
  async ({ questionnaires, sectionTitleId, files, jwt }: { questionnaires: Questionnaire[], sectionTitleId: string, files: { [key: string]: File; }, jwt: string }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const formData = new FormData();

      formData.append('questionnaire', JSON.stringify(questionnaires));
      formData.append('section_title_id', sectionTitleId);

      if (files) {
        for (const key in files) {
          if (files.hasOwnProperty(key)) {
            formData.append(key, files[key]);
          }
        }
      }

      const { data } = await axios.post(`/user/kyc/submit`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${jwt}`
        },
      });

      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);
